export const TRANSCRIPTS_PER_PAGE = 10;
